<template>

    <div class="env-label" v-if="$page.props.app.env !== 'production'">
        {{ $page.props.app.env }}
    </div>

</template>

<script>
    export default {
        props: [
        ],
    }
</script>

<style scoped>
    .env-label {
        position: sticky;
        background: red;
        top: 0;
        color: #fff;
        padding: 6px 20px;
        text-align: center;
        text-transform: uppercase;
        z-index: 2010;
    }
</style>